import { render, staticRenderFns } from "./BeHeroButonGroup.vue?vue&type=template&id=7f467f7d&scoped=true"
import script from "./BeHeroButonGroup.vue?vue&type=script&lang=js"
export * from "./BeHeroButonGroup.vue?vue&type=script&lang=js"
import style0 from "./BeHeroButonGroup.vue?vue&type=style&index=0&id=7f467f7d&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f467f7d",
  null
  
)

export default component.exports